import { render, staticRenderFns } from "./DisscussantForm.vue?vue&type=template&id=4297e394&scoped=true&"
import script from "./DisscussantForm.vue?vue&type=script&lang=js&"
export * from "./DisscussantForm.vue?vue&type=script&lang=js&"
import style0 from "./DisscussantForm.vue?vue&type=style&index=0&id=4297e394&scoped=true&lang=css&"
import style1 from "./DisscussantForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4297e394",
  null
  
)

export default component.exports